<script>
import Testimonial from "../Testimonial.vue";

export default {
  components: { Testimonial },
  name: "SpeedStartLeft",
  props: ["includeSubscription"],
  data: function() {
    return {
      testimonials: {
        kristin: {
          photo: "powerdrops/testimonial-kristin.png",
          name: "Kristín Sjofn",
          quote: `Woww!!! It is like coming out of the "dark ages"... Thanks for the class. It is not too much chemistry for me because it is so colorful and fun.`
        },
        tammy: {
          photo: "powerdrops/testimonial-tammy.png",
          name: "Tammy Kell",
          quote: `I just watched Lesson One. LOVED IT!!! Wrote a full page of notes. I absolutely LOVE learning and feel SO fortunate I found Dropsmart. I can't wait for the next lesson. VERY informative.
                    Melani, you have inspired and motivated me to continue my aromatherapy journey. I appreciate you very much. Your team as well. Leandro has been phenomenal assisting me when I've had technical problems!!
                    Please continue to include chemistry education as I feel it is truly important for the overall understanding of using and blending.`
        },
        sylvia: {
          photo: "powerdrops/testimonial-sylvia.png",
          name: "Sylvia Provenski",
          quote: `I absolutely LOVE Dropsmart! And I love our Power Drops course! I go on every day and check out different conditions and then look at which are the best oils for that condition. I'm always surprised at what I find!`
        }
      }
    };
  }
};
</script>
<template>
  <div id="pd-left-container">
    <Testimonial :testimonial="testimonials.kristin" />
    <div id="special-offer">
      <h4 style="font-weight: 700; margin-bottom: 2rem;">
        What you'll get:
      </h4>
      <img src="@/assets/images/speed-start-image-computers.png" width="100%">
    </div>
    <ul id="ul1">
        <li class="list-red-icon" v-if="includeSubscription">
          <span>Lifetime access to a 5 A-class professional training <strong>(Aroma Alphabet, Speed Start, Formulating Foundations, Aroma Empress &amp; Next Level Power Drops)</strong>.</span>
        </li>
        <li class="list-red-icon">
          <span>Certificate of attendance for all courses (shareable on social media - highlight your expertise)</span>
        </li>
        <li class="list-red-icon">
          <span>PDF lessons material (for each training and module)</span>
        </li>
        <li class="list-red-icon">
          <span>Calculator for converting drops to ml, oz, etc.</span>
        </li>
        <li class="list-red-icon">
          <span>Over 190 pages of printable workbooks &amp; templates</span>
        </li>
        <li class="list-red-icon">
          <span>90 days premium subscription to the world's most trusted essential oils research center (Dropsmart)</span>
        </li>
    </ul>
    <b-card no-body class="overflow-hidden" style="font-size: 0.8em; border: none; margin-top: 3rem">
      <b-row no-gutters>
        <b-col md="3">
          <b-card-img :src="require('@/assets/aromaempress/Just-30-Days-Guarantee.jpg')"/>
        </b-col>
        <b-col md="9">
          <b-card-body title="30-Day Money-Back Guarantee">
            <b-card-text>
            Try it <strong>100% RISK-FREE with our 30-day-money-back-guarantee</strong>. If for some reason
            you aren't on your way to real success in the first 30 days, email us and we will take care of your refund!
            This means you get 30 days of test driving, on us!
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
    <div class="testimonials">
    <Testimonial :testimonial="testimonials.tammy" />
    <Testimonial :testimonial="testimonials.sylvia" />
    </div>
  </div>
</template>

<style lang="scss">
@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

* {
  font-family: $font-family;
}

#pd-left-container {
  font-size: 1.3rem;
  flex-basis: 100%;
  margin-top: -65px;
  color: #293847;
}

#special-offer {
  margin: 2rem 1rem;
  h2 {
    font-size: 2em;
    text-transform: uppercase;
    font-weight: $font-bold;
  }
  p {
    font-size: 1.35em;
    text-align: center;
    padding: 1em;
    background-color: #ffea01;
  }
  span {
    font-size: 0.9em;
  }
}

.bonus {
   margin-left: 10px;
    display: inline;
}

#program-content {
  line-height: 1.77em;
  h4 {
    font-size: 1em;
    font-weight: 600;
    margin-bottom: 1em;
  }
  ul {
    margin-left: 1em;
    padding: 0;    
  }
}
.list-red-icon {
  background: url(../../../assets/aromaempress/red-bullet.png) no-repeat left top;
  padding: 5px 40px 0px 40px;
  margin-bottom: 20px;
  text-align: justify;
  list-style: none;
}
</style>
